/* ============================================
   KBM FABRICS - BASE JAVASCRIPT
   Loader, Particles, Scroll Progress, Reveal
   ============================================ */

(function() {
  'use strict';

  /* ===== LOADER (only shows on first session visit) ===== */
  window.addEventListener('load', function() {
    setTimeout(function() {
      var loader = document.getElementById('kbm-loader');
      if (loader) loader.classList.add('hidden');
      try { sessionStorage.setItem('kbm-loader-seen', '1'); } catch (e) {}
    }, 800);
  });

  /* ===== SCROLL PROGRESS BAR ===== */
  window.addEventListener('scroll', function() {
    var scrollTop = window.scrollY;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    var bar = document.getElementById('kbm-scroll-progress');
    if (bar) bar.style.width = pct + '%';
  });

  /* ===== PARTICLES ===== */
  document.addEventListener('DOMContentLoaded', function() {
    var pc = document.getElementById('kbm-particles');
    if (!pc) return;
    var colors = ['#D94F3B','#E8833A','#F2C542','#7BBF5E','#4BA89C','#5B8EC9'];
    for (var i = 0; i < 15; i++) {
      var p = document.createElement('div');
      p.classList.add('particle');
      var s = Math.random() * 7 + 3;
      p.style.width = s + 'px';
      p.style.height = s + 'px';
      p.style.background = colors[Math.floor(Math.random() * colors.length)];
      p.style.left = Math.random() * 100 + '%';
      p.style.animationDuration = (Math.random() * 15 + 12) + 's';
      p.style.animationDelay = (Math.random() * 10) + 's';
      pc.appendChild(p);
    }
  });

  /* ===== SCROLL REVEAL (IntersectionObserver) ===== */
  document.addEventListener('DOMContentLoaded', function() {
    var revObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(function(el) {
      revObs.observe(el);
    });
  });

  /* ===== COUNTER ANIMATION ===== */
  document.addEventListener('DOMContentLoaded', function() {
    function animateCounter(el) {
      if (el.dataset.counted) return;
      el.dataset.counted = '1';
      var target = parseInt(el.dataset.target);
      var suffix = el.dataset.suffix || '+';
      if (isNaN(target)) return;
      var current = 0;
      var inc = target / 50;
      var timer = setInterval(function() {
        current += inc;
        if (current >= target) { current = target; clearInterval(timer); }
        el.textContent = Math.floor(current).toLocaleString() + suffix;
      }, 25);
    }

    /* Use a low threshold so it fires even when parent is mid-reveal */
    var cObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          /* Delay slightly so the reveal animation has kicked in */
          setTimeout(function() { animateCounter(entry.target); }, 400);
          cObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

    document.querySelectorAll('.stat-number[data-target]').forEach(function(el) {
      cObs.observe(el);
    });
  });

  /* ===== SEAMLESS INFINITE MARQUEE ===== */
  window.kbmInitMarquee = function(el, speed, divisor) {
    if (!el) return;
    var pos = 0;
    var resetAt = el.scrollWidth / divisor;
    function tick() {
      pos -= speed;
      if (pos <= -resetAt) pos += resetAt;
      el.style.transform = 'translateX(' + pos + 'px)';
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  };

})();
